// The manufacturer name for first-party Velavu devices
export const DEVICE_MODEL_MANUFACTURER_VELAVU = "Velavu";
export var DeviceIndicatorType;
(function (DeviceIndicatorType) {
    DeviceIndicatorType["LED"] = "led";
    DeviceIndicatorType["Buzzer"] = "buzzer";
})(DeviceIndicatorType || (DeviceIndicatorType = {}));
//# sourceMappingURL=device-model.js.map